export { IonicImageViewerModule } from './src/module';
export { ImageViewerComponent } from './src/image-viewer.component';
export { ImageViewerDirective } from './src/image-viewer.directive';
//# sourceMappingURL=ionic-img-viewer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-img-viewer/dist/ionic-img-viewer.js
// module id = 512
// module chunks = 73